module.exports = __webpack_public_path__ + "static/media/ic_Pick-Up.24c0229f.svg";